import CardMui from '@mui/material/Card';
import CardActionsMui from '@mui/material/CardActions';
import CardActionArea from '@mui/material/CardActionArea';
import Rating from '@mui/material/Rating';
import cornerSVG from '@/pages/company/WorkspaceRoute/components/TileGrid/TileCard/components/corner.svg';
import cornerRtlSVG from '@/pages/company/WorkspaceRoute/components/TileGrid/TileCard/components/corner-rtl.svg';

import { styled, alpha } from '@mui/material/styles';

export const TILE_Z_INDEXES = {
  publishFailedOverlay: 1,
  cardNote: 10,
  isWarning: 20, // overlap card note
  linkedBadge: 20,
  copyBadge: 20,
  multiPageCorner: 20,
  userTagAvatars: 20,
  previewEye: 30, // overlap all elements
};

export const THUMBNAIL_H = 194;

export const Tile = styled(CardMui, {
  shouldForwardProp: (propName) => propName !== 'selected',
  label: 'Tile',
})(({ theme, selected }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.grey[200]}`,
  ...(selected && { borderColor: theme.palette.primary.main, outline: `2px solid ${theme.palette.primary.main}` }),
}));

export const TileActionArea = styled(CardActionArea, {
  label: 'TileActionArea',
})(() => ({
  '& .MuiCardActionArea-focusHighlight': {
    backgroundColor: 'transparent',
    opacity: 0.5,
  },

  '&:hover .MuiCardActionArea-focusHighlight': {
    opacity: 1,
  },
}));

export const TileActions = styled(CardActionsMui, { label: 'TileActions' })(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  height: 44,
  borderTop: `1px solid ${theme.palette.grey[200]}`,
}));

export const MultipageCorner = styled('div', { label: 'MultipageCorner' })(({ theme }) => ({
  backgroundImage: `url(${theme.direction === 'rtl' ? cornerRtlSVG : cornerSVG})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  position: 'absolute',
  top: -2,
  right: -2,
  width: 90,
  height: '100%',
}));

export const FavoriteIcon = styled(Rating, { label: 'FavoriteIcon' })(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  left: theme.spacing(1),
}));

export const DocumentWithWarning = styled('div', {
  label: 'TileActionAreaDocumentWithWarning',
})(({ theme }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  width: 5,
  backgroundColor: theme.palette.error.main,
  zIndex: TILE_Z_INDEXES.isWarning, // for overlap image
}));

export const PublishFailedOverlay = styled('div', {
  label: 'TileActionAreaPublishFailedOverlay',
})(({ theme }) => ({
  position: 'absolute',
  inset: 0,
  backgroundColor: alpha(theme.palette.error.main, 0.12),
  zIndex: TILE_Z_INDEXES.publishFailedOverlay,
}));
